import { Role } from "./role";
import { Identifiable } from "./identifiable";
import { Tag } from "./tag";
import { CostProfile } from "./costProfile";
import { OrganizationalUnit } from "./organizationalUnit";
import { ResourceTypes } from "./resourceTypes";
import { CalendarHolidays } from "./calendarHolidays";

type Resource = {
  type: ResourceTypes;
  role?: Identifiable<Role>;
  name: string;
  avatarUrl: string;
  profession: string;
  description: string;
  createdDate: string;
  integratedAt: string | null;
  invitationAccepted: boolean;
  affiliation: "INTERNAL" | "EXTERNAL" | null;
  costProfile?: Identifiable<CostProfile> | null;
  organizationalUnit?: Identifiable<OrganizationalUnit> | null;
  userInfo?: {
    email: string;
    firstName: string;
    lastName: string;
    username: string;
  };
  tags: Tag[];
  deactivated: boolean;
  calendarHolidays?: Identifiable<CalendarHolidays>;
  attributes?: { [key: string]: string };
  subordinates?: Identifiable<Resource>[];
};

const resource: Resource = {
  type: ResourceTypes.VIRTUAL,
  avatarUrl: "",
  name: "",
  profession: "",
  description: "",
  createdDate: "",
  invitationAccepted: true,
  affiliation: null,
  integratedAt: "",
  tags: [],
  deactivated: false,
};

export type { Resource };

export { resource };
